import { SETTINGS_SET_VIEW_MODE } from './types';

export const mutations = {
  [SETTINGS_SET_VIEW_MODE]: (state, payload) => {
    state.viewMode = payload;
  }
};
